var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "field" }, [
    _c("label", { staticClass: "label" }, [_vm._v(_vm._s(_vm.label))]),
    _c(
      "div",
      { staticClass: "control" },
      [
        _c("multiselect", {
          attrs: {
            name: _vm.name,
            "track-by": "id",
            label: "name",
            options: _vm.organisations,
            value: _vm.myValue,
            searchable: true,
            loading: _vm.isFetching,
            "deselect-label": "Press enter to clear",
          },
          on: { input: _vm.myBlur },
        }),
      ],
      1
    ),
    _vm.showError
      ? _c("p", { staticClass: "help is-danger" }, [_vm._v(_vm._s(_vm.error))])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }